import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';
import { Text } from 'components/primitives/typography';
import { Box } from 'components/primitives/box';
import { boatAmenitiesTempAtom } from '../filterStore';
import { renderAtomCheckbox } from '../fields/AtomCheckbox';

const categories = {
  Popular: ['bathroom', 'bluetooth_audio', 'floating_mat', 'grill', 'gps', 'refrigerator', 'shower', 'wakeboard'],
  Recreational: ['inflatable_toys', 'paddleboards', 'snorkeling_gear', 'waterskis'],
  Fishing: ['fish_finder', 'fishing_gear', 'livewell_/_baitwell'],
  Safety: ['childrens_life_jackets', 'swim_ladder'],
  Comfort: ['air_conditioning', 'cooler_/_ice_chest', 'stereo', 'wifi'],
};

const BoatAmenitiesContent: React.FC = () => {
  const amenities = useAtomValue(boatAmenitiesTempAtom);
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded(!expanded);

  const categoriesToShow = expanded ? Object.keys(categories) : ['Popular'];

  return (
    <Box>
      {categoriesToShow.map((category) => (
        <CategorySection key={category}>
          <CategoryTitle>{category}</CategoryTitle>
          <AmenitiesGrid>
            {categories[category].map((item) => {
              const amenity = amenities.find((a) => a.value === item);
              return amenity ? renderAtomCheckbox(amenity) : null;
            })}
          </AmenitiesGrid>
        </CategorySection>
      ))}
      <ExpandButton onClick={toggleExpanded}>{expanded ? 'View less' : 'View all'}</ExpandButton>
    </Box>
  );
};

const CategorySection = styled(Box)`
  margin-bottom: 24px;
`;

const CategoryTitle = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 16px;
`;

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`;

const ExpandButton = styled.div`
  margin-top: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #17263c;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-decoration: underline;
`;

export default BoatAmenitiesContent;
